module.exports = __webpack_public_path__ + "static/media/rebirth_16.892698a9.jpg";